<template>
  <div id="loader">
    <div
      class="fixed z-50 inset-0 align-middle content-center"
      id="loadingOverlay"
    >
      <div
        class="flex h-screen items-end justify-center align-middle min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div class="fixed inset-0 transition-opacity">
          <div class="absolute inset-0 bg-black opacity-50"></div>
        </div>

        <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>

        <div
          class="inline-block m-auto items-center transform transition-all align-middle justify-items-center content-center"
        >
          <div
            class="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-32 w-32"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.loader { 
  border-top-color: #66b32f;
  -webkit-animation: spinner 1.5s linear infinite;
  animation: spinner 1.5s linear infinite;
}

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
